/*
    The pre-active state displays when the amortizationMonth = 0
*/

import { CompanyFragment, LoanStatus } from '@willow/graphql-iso/src/portal';
import { phoneNumberFormat } from '@willow/shared-iso';
import { Badge, paymentDateFormat } from '@willow/shared-web';

import { PageHeading } from '../../page-heading/PageHeading';

interface Props {
  company: CompanyFragment;
  loanStatus: LoanStatus;
  nextStatementDate: string | undefined;
}

export const PreActive = ({ company, loanStatus, nextStatementDate }: Props) => {
  const isPendingActivation = loanStatus === LoanStatus.PendingActivation;

  return (
    <>
      <div className="text-center mb-3">
        <Badge variant="info-inverted">Statement Pending</Badge>
      </div>
      <PageHeading
        title="No payment due"
        subtitle={isPendingActivation ? undefined : `First statement available ${paymentDateFormat(nextStatementDate)}`}
      />

      <div className="u-container mt-5">
        <section className="pb-4 mb-4 u-border-b-1 u-border-color-bark1">
          <h2 className="u-fs-4 fw-bold">
            You will receive details of your first payment{' '}
            <span>{isPendingActivation ? 'soon' : `on ${paymentDateFormat(nextStatementDate, true)}`}</span>
          </h2>
          <div className="mt-2 u-color-bark3">
            Once you have received a notification that your payment is due you will be able to connect your preferred
            bank account and submit your payment online.
          </div>
        </section>
        <section>
          <h2 className="u-fs-4 fw-bold">Do you have questions?</h2>
          <div className="mt-2 u-color-bark3">
            Contact us by phone at{' '}
            <a href={`tel: ${company.supportPhone}`} aria-label={`phone number: ${company.supportPhone}`}>
              {phoneNumberFormat(company.supportPhone)}
            </a>{' '}
            or by email at <a href={`mailto:${company.supportEmail}`}>{company.supportEmail}</a> for assistance.
          </div>
        </section>
      </div>
    </>
  );
};
